import { createContext, useContext, useState } from "react";
import { content } from "@/i18n/content";

const LangCtx = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState("es");
  return (
    <LangCtx.Provider value={{ lang, setLang, t: content[lang] }}>
      {children}
    </LangCtx.Provider>
  );
};

export const useLang = () => useContext(LangCtx);
